import { ConfigurationService, DialogService } from '@sdbn/appclient';
import { FlowStepHandleResult, HandleResultType, StepControl, AbstractStepController, WizardServiceLocator } from '@sdbn/appclient';
import { ContextChange } from '@sdbn/appclient';

export class TerminalConfigurationController extends AbstractStepController {

    configurationService: ConfigurationService;

    constructor() {
        super();
        this.configurationService = WizardServiceLocator.injector.get(ConfigurationService);
    }

    onContextChange(contextChange: ContextChange) {
    }

    onRegisterToDashboardContext() {

    }

    public handleFlow(): FlowStepHandleResult {
      console.log('TerminalConfiguration.handleFlow');
      const config = this.wizardComponent.currentStep.dashboardConfiguration;
      const terminalIdentifier = config.terminalIdentifier;
      if (terminalIdentifier != null) {
        this.dashboardContext.setContextValue('terminalIdentifier', terminalIdentifier);
        this.configurationService.loadDeviceParameters(terminalIdentifier).subscribe(() => {
          console.log('-----> device config loaded');
          this.wizardComponent.next();
        }, error => {
          console.log('loadDeviceParameters call failed:', error);
          this.showHttpError();
        });
      }
      const result = new FlowStepHandleResult();
      result.type = HandleResultType.PROCESSING;
      console.log('-----> handleFlow return result');
      return result;
    }

    getControls(): StepControl[] {
        return new Array<StepControl>();
    }

    private showHttpError() {
        const dialogService = WizardServiceLocator.injector.get(DialogService);
        dialogService.showInfoDialog(
          'tmc-yard.widgets.registration-terminal.http.error.title',
          'tmc-yard.widgets.registration-terminal.http.error.message'
        ).afterClosed().subscribe(
            () => this.wizardComponent.restartWizard()
        );
    }
}
